<qa-content-spinner [active]="loading">
  <div class="answer-wrapper">
    <ng-scrollbar>
      <div
        class="answer-stats-wrapper"
        data-cy="answerStatsWrapper"
        [class.loader]="loading"
      >
        <table
          class="user-overview"
          [class.freeText]="question.type === questionType.FREETEXT"
        >
          <tr>
            <td>
              <div class="question-stat-data">
                <button
                  data-cy="backToResult"
                  mat-button
                  (click)="goBackToResult()"
                >
                  <mat-icon class="back-btn">keyboard_backspace</mat-icon>
                  {{ 'exam.result.backToOverView' | translate }}
                </button>
                <div class="question-data" data-cy="questionData">
                  @if ( question?.type !== questionType.FREETEXT &&
                  !question?.is_poll_question) {
                  <div
                    class="right-or-wrong flex-row flex-justify-content-space-between flex-align-items-center"
                  >
                    <div class="bar">
                      <div
                        [style.width]="getRightResult(question)"
                        class="right-ans"
                      ></div>
                      <div
                        [style.width]="getWrongResult(question)"
                        class="wrong-ans"
                      ></div>
                    </div>
                  </div>
                  <div>
                    {{ question.num_correct_answers }}/{{
                      question.total_result - question.num_correct_answers
                    }}{{ !hideUnAnswered ? '/' + question.num_unanswered : '' }}
                  </div>
                  @if ( question?.type !== questionType.FREETEXT &&
                  !question?.is_poll_question ) {
                  <div>
                    {{ getCorrectRatio(question) }}
                  </div>
                  } } @else {
                  <span class="open-question-indicator">
                    {{
                      'exam.result.numOfAnswer'
                        | translate : { count: question.total_num_answers }
                    }}
                  </span>
                  }
                </div>
              </div>
            </td>
            <td>
              <qa-import-exam-navigation
                [currentItemPosition]="currentItemIndex + 1"
                [itemCount]="allQuestions?.length"
                (navigation)="onNavigate($event)"
              >
              </qa-import-exam-navigation>
            </td>
          </tr>
        </table>
        <div class="exam-name" data-cy="examName">
          @if (question?.media?.uuid) {
          <qa-image-display [model]="question"></qa-image-display>
          }
          <div class="question-wrapper">
            <qa-markdown-katex
              class="question-over-text"
              [data]="question.text"
            >
            </qa-markdown-katex>
            @if ( question?.has_explanation || question?.type ===
            questionType.FREETEXT ) {
            <mat-accordion [displayMode]="'flat'">
              @if (question?.has_explanation && question?.explanation) {
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon>help</mat-icon>
                    <u>{{ 'question.form.explanation' | translate }}</u>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="explanation-content">
                  <qa-markdown-katex
                    [data]="question.explanation"
                    [hideError]="true"
                  >
                  </qa-markdown-katex>
                </div>
              </mat-expansion-panel>
              } @if (question?.type === questionType.FREETEXT && sampleAnswer) {
              <mat-expansion-panel hideToggle>
                <mat-expansion-panel-header>
                  <mat-panel-title>
                    <mat-icon>info</mat-icon>
                    <u>{{ 'question.label.sampleAnswer' | translate }}</u>
                  </mat-panel-title>
                </mat-expansion-panel-header>
                <div class="explanation-content">
                  <qa-sample-answer
                    [info]="sampleAnswer"
                    (textBoxValueChange)="handleSampleAnswerChange($event)"
                  ></qa-sample-answer>
                </div>
              </mat-expansion-panel>
              }
            </mat-accordion>
            }
          </div>
        </div>
        @if (question?.is_poll_question) {
        <div class="visualization-selector">
          <mat-button-toggle-group
            [value]="selectedVisualization"
            (change)="selectedVisualization = $event.value"
          >
            @if (question?.type === questionType.FREETEXT) {
            <mat-button-toggle value="cloud"
              ><mat-icon>abc</mat-icon></mat-button-toggle
            >
            }
            <mat-button-toggle value="list"
              ><mat-icon>view_list</mat-icon></mat-button-toggle
            >
            <mat-button-toggle value="donut"
              ><mat-icon>donut_large</mat-icon></mat-button-toggle
            >
            @if (question?.type === questionType.FREETEXT) {
            <mat-button-toggle value="card"
              ><mat-icon>space_dashboard</mat-icon></mat-button-toggle
            >
            }
          </mat-button-toggle-group>
        </div>
        }
        <div class="answers-wrapper">
          @if ( question?.is_poll_question && question?.type ===
          questionType.FREETEXT && selectedVisualization === 'cloud') {
          <qa-word-cloud-visualization
            [words]="mapToStrings()"
          ></qa-word-cloud-visualization>
          } @else { @if ( selectedVisualization === 'donut' &&
          question.is_poll_question) {
          <qa-donut-chart
            [sections]="answerSections"
            [cutout]="68"
            [sort]="true"
            [large]="true"
          >
          </qa-donut-chart>
          } @else { @if ( selectedVisualization === 'card' && question?.type ===
          questionType.FREETEXT && question.is_poll_question) {
          <qa-free-text-answers-grid
            [answers]="question?.answers"
          ></qa-free-text-answers-grid>
          } @else { @if ( question.type !== questionType.FREETEXT ||
          (question.type === questionType.FREETEXT &&
          question.is_poll_question)) { @for (answerStat of question?.answers;
          track $index) {
          <div
            [class.correct]="answerStat?.is_right || question?.is_poll_question"
            [class.isPoll]="question?.is_poll_question"
            class="answer"
          >
            @if (!question?.is_poll_question) {
            <div class="radio-checkbox">
              @if (question.type === questionType.MULTIPLE_CHOICE) {
              <mat-checkbox
                disabled
                [checked]="answerStat?.is_right"
                [ngClass]="{
                  'disabled-checkbox': answerStat?.is_right === false
                }"
              ></mat-checkbox>
              } @if (question.type !== questionType.MULTIPLE_CHOICE) {
              <div class="radio-button">
                <div class="mat-radio-inner-circle-style"></div>
              </div>
              }
            </div>
            }
            <div class="answer-text" data-cy="answerText">
              <div class="top">
                <qa-markdown-katex
                  [data]="
                    question.type === questionType.TRUE_FALSE
                      ? translateTrueFalse(answerStat.text)
                      : answerStat.text
                  "
                  class="text"
                >
                </qa-markdown-katex>
                <div class="amount">
                  {{ answerStat.num_selected }}
                </div>
              </div>
              <div class="bar">
                <div
                  [style.width]="getAnswerBarWidth(answerStat.num_selected)"
                  class="piece"
                ></div>
              </div>
            </div>
          </div>
          } } @else { @if (question?.results?.length) {
          <div class="freetext-answers">
            <div class="header">
              <span class="name">{{ 'Name' | translate }}</span>
              <span class="text">{{ 'question.form.answer' | translate }}</span>
              @if (!gradingAllInProgress) {
              <button
                mat-raised-button
                class="grade-all primary"
                [matMenuTriggerFor]="gradeWithAiMenu"
              >
                <span>{{ 'question.gradeWithAI' | translate }}</span>
                <img src="assets/icons/chat-gpt.svg" alt="gpt" />
              </button>
              }
              <mat-menu #gradeWithAiMenu="matMenu">
                <button
                  mat-menu-item
                  (click)="gradeAllWithAi(question?.results, false)"
                >
                  {{ 'question.gradeAll' | translate }}
                </button>
                <button
                  mat-menu-item
                  (click)="gradeAllWithAi(question?.results, true)"
                  [disabled]="!question?.openQuestionAnsweredCount"
                >
                  {{ 'question.gradeAllUngraded' | translate }}
                </button>
              </mat-menu>
              @if (gradingAllInProgress) {
              <button
                mat-raised-button
                class="grade-all warn"
                (click)="cancelRequest()"
              >
                <span>{{ 'question.stopProcessing' | translate }}</span>
                <mat-icon class="close-icon" color="warn">close</mat-icon>
              </button>
              }
              <span class="state">
                @if (question?.openQuestionAnsweredCount) {
                <qa-custom-chip [label]="labelAnswers"></qa-custom-chip>
                }
              </span>
              <span class="grade">{{ 'exam.result.points' | translate }}</span>
            </div>
            <qa-content-spinner
              [class.gradeLoader]="gradingAllInProgress"
              [loadingText]="'AIQuestionImports.loadingText' | translate"
              [active]="gradingAllInProgress"
            >
              @for (submission of question?.results; track $index) {
              <div class="freetext-answer">
                <div class="name">{{ submission.user?.username }}</div>
                <div class="text">
                  <div class="user-answer-container">
                    <div class="user-answer">
                      <div class="text-shorten">
                        {{
                          submission?.selected_answers?.length
                            ? submission?.selected_answers[0].text
                            : null
                        }}
                      </div>
                    </div>
                    <div class="reply" [class.active]="submission?.addReply">
                      <mat-form-field appearance="fill">
                        <mat-label>{{
                          'exam.result.reply' | translate
                        }}</mat-label>
                        <textarea
                          matInput
                          type="text"
                          rows="10"
                          [(ngModel)]="submission.free_text_feedback"
                        ></textarea>
                      </mat-form-field>
                      <div class="comment-submit-actions">
                        <qa-button
                          label="common.button.abort"
                          (submitted)="
                            submission.addReply = !submission.addReply
                          "
                          type="submit"
                        ></qa-button>
                        <qa-button
                          [isRaisedButton]="true"
                          label="common.button.save"
                          (submitted)="setFeedback.emit(submission)"
                          type="submit"
                        ></qa-button>
                      </div>
                    </div>
                  </div>
                  <button
                    mat-icon-button
                    class="add-reply"
                    [matTooltip]="'Antworten'"
                    (click)="showFeedback(submission)"
                  >
                    <mat-icon
                      [class.material-icons]="submission.free_text_feedback"
                      >comment</mat-icon
                    >
                  </button>
                  @if (isExam) {
                  <button
                    mat-icon-button
                    class="add-reply"
                    [matTooltip]="'AIQuestionImports.evalProposal' | translate"
                    (click)="generateExplanation(submission)"
                  >
                    <img
                      src="assets/icons/chat-gpt.svg"
                      alt="gpt"
                      class="ng-tns-c551-113"
                    />
                  </button>
                  }
                </div>
                <div
                  class="state"
                  [class.open]="
                    submission?.score === null ||
                    submission?.score === undefined
                  "
                  [class.done]="
                    submission?.score !== undefined &&
                    submission?.score !== null &&
                    submission?.score !== 0
                  "
                  [class.close]="submission?.score === 0"
                >
                  <button mat-icon-button>
                    @if ( submission?.score !== undefined && submission?.score
                    !== null && submission?.score !== 0 ) {
                    <mat-icon>done</mat-icon>
                    } @if (submission?.score === 0) {
                    <mat-icon>close</mat-icon>
                    } @if ( submission?.score === null || submission?.score ===
                    undefined ) {
                    <mat-icon>question_mark</mat-icon>
                    }
                  </button>
                </div>
                <div class="grade">
                  <span
                    class="grade-select"
                    [matMenuTriggerFor]="gradeSelectMenu"
                    [class.freeText]="question.type === questionType.FREETEXT"
                    data-cy="grade"
                  >
                    {{ submission?.score ?? '---' }}
                  </span>
                  <mat-menu #gradeSelectMenu="matMenu">
                    <button
                      mat-menu-item
                      (click)="selectScoreQuestion({submission, score: null})"
                    >
                      ---
                    </button>
                    @for ( scoreStep of scoreSteps(question.max_score ?? 0) ;
                    track $index) {
                    <button
                      mat-menu-item
                      (click)="selectScoreQuestion({submission, score: scoreStep})"
                      data-cy="scoreStep"
                    >
                      {{ scoreStep }}
                    </button>
                    }
                  </mat-menu>
                  <span class="total-score"
                    >/ {{ question.max_score ?? 0 }}</span
                  >
                </div>
              </div>
              }
            </qa-content-spinner>
          </div>
          } } } } }
        </div>
      </div>
    </ng-scrollbar>
  </div>
</qa-content-spinner>
